import { Direction, Divider } from '@mui/material';
import { getApplicationDirection } from '@nice-ccf/ui-components';
import {
  CcfAppHealthIcon,
  CcfBox,
  CcfHeader,
  CcfTypography,
  useTranslator,
  CcfSlider,
  CcfButton,
} from '@nice-ccf/ui-controls';
import { useSelector } from 'react-redux';
import styles from './ccf-app-health.module.scss';
import {
  getLoggedInUser,
  selectLoginCredentialsState,
} from '../../login/+state/login.slice';
import { useState } from 'react';
import { browserName, browserVersion } from 'react-device-detect';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';

/* eslint-disable-next-line */
export interface CcfAppHealthProps {}

/**
 * used to show App Health(Network status) static screen
 * @param props - CcfAppHealthProps
 * @example ` <CcfAppHealth inboxCardState={inboxCardState} />`
 */
export function CcfAppHealth(props: CcfAppHealthProps) {
  const appDirection: Direction = useSelector(getApplicationDirection);
  const [translate] = useTranslator();
  const userData = useSelector(getLoggedInUser);
  const isAuthenticated = useIsAuthenticated();
  const { accounts } = useMsal();
  const loginCredentials = useSelector(selectLoginCredentialsState);
  const loginCredentialsFromSSO = accounts[0]?.name || ' ';
  const loginCredentialsArray = loginCredentialsFromSSO?.split(' ');
  const agentName = isAuthenticated
    ? loginCredentialsArray[0].charAt(0).toUpperCase() +
      loginCredentialsArray[0].slice(1).toLowerCase() +
      ' ' +
      loginCredentialsArray[1].charAt(0).toUpperCase() +
      loginCredentialsArray[1].slice(1).toLowerCase()
    : loginCredentials.firstName.charAt(0).toUpperCase() +
      loginCredentials.firstName.slice(1).toLowerCase() +
      ' ' +
      loginCredentials.lastName.charAt(0).toUpperCase() +
      loginCredentials.lastName.slice(1).toLowerCase();

  return (
    // <div className={className.get(props.inboxCardState)}>
    //   <img className={styles.fitImage} src="./../assets/Network_Status_Static_Image.png" alt="App Health" />
    // </div>

    <section className={styles.networkHealthContainer}>
      {/* <CcfBox component="div" className={styles.networkHealthHeader}>
        <CcfHeader
            LeftIcon={
              <CcfAppHealthIcon className={styles.networkStatusIcon} />
            }
            headerText={translate('networkStatus')}
            RightIcon
            showDragIcon
            direction={appDirection}
        /> 
      </CcfBox> */}

      <CcfBox
        component="div"
        ml={2.5}
        height={'20%'}
        display="flex"
        flexDirection={'column'}
        className={styles.networkHeaderSlider}
      >
        <CcfBox component="div" className={styles.networkHeader}>
          <CcfBox
            component="div"
            display="flex"
            flexDirection={'column'}
            justifyContent={'space-evenly'}
            height={'100%'}
          >
            <CcfTypography className={styles.networkStatusTitle}>
              {translate('networkstatus')}
            </CcfTypography>
            <CcfTypography className={styles.networkStatusSubTitle}>
              Wed July 15th 2020 10:16:24 AM (Mountain Daylight Time)
            </CcfTypography>
          </CcfBox>
          <CcfButton primary className={styles.reloadAppBtn}>
            {translate('reloadApplication')}
          </CcfButton>
        </CcfBox>
        <CcfBox
          component="div"
          className={styles.sliderContainer}
          display="flex"
        >
          <CcfTypography className={styles.sliderMinValue}>0(s)</CcfTypography>
          <CcfSlider />
          <CcfTypography className={styles.sliderMaxValue}>4.00</CcfTypography>
        </CcfBox>
      </CcfBox>
      <div className={styles.divider} />

      <CcfBox component="div" className={styles.networkContent}>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('agentName')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{agentName}</CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('displayedUsername')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {isAuthenticated
                ? accounts[0]?.username
                : loginCredentials?.email}
            </CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('agentId')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {userData.agentID}
            </CcfTypography>
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('version')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'5913364b53'}
            </CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('stationId')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'N/A'}</CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('sessionId')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'436651778'}
            </CcfTypography>
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('phoneNumber')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'WebRTC'}</CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('agentLegId')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'N/A'}</CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('callerId')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'4005554444'}
            </CcfTypography>
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('browserVersion')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'Chrome 83'}
            </CcfTypography>
          </CcfBox>

          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('webServer')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'—'}</CcfTypography>
          </CcfBox>

          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('virtualCluster')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'SOB-C32COR01'}
            </CcfTypography>
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('browserLanguage')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'en-US'}</CcfTypography>
          </CcfBox>

          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('browserLocalization')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'en-US'}</CcfTypography>
          </CcfBox>

          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('team')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {userData?.team}
            </CcfTypography>
          </CcfBox>
        </CcfBox>

        <div style={{ width: '109%' }} className={styles.divider} />

        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('interactionRouting')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {userData.firstName} {userData.lastName}
            </CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('routing')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'Omni'}</CcfTypography>
          </CcfBox>

          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('contactLimit')}
            </CcfTypography>

            <CcfTypography className={styles.value}>
              {'1 call, 2 emails, 4 chats'}
            </CcfTypography>
          </CcfBox>
        </CcfBox>
        <CcfBox className={styles.networkContentBlock}>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('reqContact')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'Enabled'}</CcfTypography>
          </CcfBox>

          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('totalLimit')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'16'}</CcfTypography>
          </CcfBox>
          <CcfBox component="div" className={styles.titleValueContainer}>
            <CcfTypography className={styles.title}>
              {translate('contactAutoFocus')}
            </CcfTypography>

            <CcfTypography className={styles.value}>{'Enabled'}</CcfTypography>
          </CcfBox>
        </CcfBox>
      </CcfBox>
    </section>
  );
}
